import { NavLink } from "react-router-dom";
import {
    FaHome,
    FaBuilding,
    FaCalendarAlt,
    FaFileAlt,
    FaBookOpen,
    FaChevronLeft,
    FaChevronRight,
} from "react-icons/fa";
import { useIsMobile } from "../../hooks/use-mobile";
import { getImg } from "../../Api/getImg";
import { IoBarChartSharp } from "react-icons/io5";
import { HiSparkles, HiUserMinus } from "react-icons/hi2";
import { FaServer, FaUserAstronaut } from "react-icons/fa6";
import { FaBlog } from "react-icons/fa6";
import { BsClock, BsImages, BsQrCode } from "react-icons/bs";
import { PiPackage } from "react-icons/pi";
import { TbPackages } from "react-icons/tb";
import { SiUnsplash } from "react-icons/si";
import { LuUserRound } from "react-icons/lu";

const Sidebar = ({ isOpen, onToggle, user, isLoading, role }) => {
    const isMobile = useIsMobile();
console.log(role);

    const navItems = [
        { name: "Scan Qr", path: "/scanQr", icon: <BsQrCode />, allowedRoles: [2,5] },
        { name: "Dashboard", path: "/dashboard", icon: <FaHome />, allowedRoles: [2] },
        // { name: "Insights", path: "/insights", icon: <IoBarChartSharp />, allowedRoles: [2] },
        { name: "Clinics", path: "/clinics", icon: <FaBuilding />, allowedRoles: [2] },
        // { name: "Coming Patient", path: "/comming-patient", icon: <LuUserRound />, allowedRoles: [5] },
        { name: " Sessions", path: "/sessions", icon: <BsClock />, allowedRoles: [5] },
        { name: "Current Active Patient", path: "/active-patient", icon: <FaUserAstronaut />, allowedRoles: [2] },
        { name: "Patients", path: "/patients", icon: <HiUserMinus />, allowedRoles: [2] },
        { name: "Schedule", path: "/schedule", icon: <FaCalendarAlt />, allowedRoles: [2] },
        { name: "Form Builder", path: "/form-builder", icon: <FaFileAlt />, allowedRoles: [2] },
        { name: "Bookings", path: "/bookings", icon: <FaBookOpen />, allowedRoles: [2] },
        // { name: "Services", path: "/Services", icon: <FaServer />, allowedRoles: [2] },
        // { name: "Blogs", path: "/blogs", icon: <BsImages />, allowedRoles: [2] },
        // { name: "Packages", path: "/packages", icon: <TbPackages />, allowedRoles: [2] },
        { name: "Subscription", path: "/sub", icon: <HiSparkles />, allowedRoles: [2] },
    ];

    // Filter navigation items based on user role
    const filteredNavItems = navItems.filter(item => 
        item.allowedRoles.includes(Number(role))
    );

    console.log(filteredNavItems);
    
    // Mobile backdrop
    const Backdrop = () => (
        isMobile && isOpen ? (
            <div
                className="fixed inset-0 bg-black/50 z-40 transition-opacity duration-300"
                onClick={onToggle}
            />
        ) : null
    );

    return (
        <>
            <Backdrop />
            <div className={`
                fixed h-full bg-white border-r border-gray-200 transition-all duration-300 shadow-lg flex flex-col
                ${isMobile
                    ? `w-72 z-50 ${isOpen ? 'left-0' : '-left-72'}`
                    : `z-30 ${isOpen ? 'w-64' : 'w-16'}`
                }
            `}>
                {/* Header */}
                <div className="flex items-center justify-between p-3 sm:p-4 border-b h-14 sm:h-16 flex-shrink-0">
                    <div className="flex items-center min-w-0">
                        {(isOpen || isMobile) && (
                            <>
                                <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-md bg-primary flex items-center justify-center mr-2 flex-shrink-0">
                                    <span className="text-white font-bold text-sm sm:text-base">DE</span>
                                </div>
                                <img
                                    src="https://res.cloudinary.com/dk2uh7sho/image/upload/v1752771874/dreasy_1_n6ygy8.png"
                                    className="w-20 sm:w-24 lg:w-28 mt-1 min-w-0"
                                    alt="DrEasy Logo"
                                />
                            </>
                        )}
                    </div>
                    {!isMobile && (
                        <button
                            onClick={onToggle}
                            className="text-gray-500 hover:text-gray-700 p-1 rounded-md hover:bg-gray-100 transition-colors flex-shrink-0 flex items-center justify-center gap-1"
                        >
                            <div className={`${isOpen ? "hidden" : "flex"} w-4 h-4 sm:w-5 sm:h-5 rounded-md bg-primary flex items-center justify-center flex-shrink-0`}>
                                <span className="text-white font-bold text-xs">DE</span>
                            </div>
                            {isOpen ? (
                                <FaChevronLeft className="w-4 h-4" />
                            ) : (
                                <FaChevronRight className="w-4 h-4" />
                            )}
                        </button>
                    )}
                </div>

                {/* Navigation items - always show on mobile when open, conditional on desktop */}
                <div className={`flex-1 overflow-y-auto ${!isMobile && !isOpen ? 'hidden' : ''}`}>
                    <nav className="mt-4 sm:mt-6 pb-4 sm:pb-6">
                        <ul className="space-y-1 sm:space-y-2 px-2 sm:px-3">
                            {filteredNavItems.map((item) => (
                                <li key={item.path}>
                                    <NavLink
                                        to={item.path}
                                        end={item.path === "/"}
                                        className={({ isActive }) => `
                                            flex items-center p-2.5 sm:p-3 rounded-md transition-all duration-200 group
                                            ${isActive
                                                ? "bg-primary/10 text-primary font-medium"
                                                : "text-gray-700 hover:bg-gray-100 hover:text-gray-900"}
                                        `}
                                        onClick={isMobile ? onToggle : undefined}
                                    >
                                        <span className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center flex-shrink-0">
                                            {item.icon}
                                        </span>
                                        <span className="ml-3 text-sm sm:text-base font-medium truncate">
                                            {item.name}
                                        </span>
                                    </NavLink>
                                </li>
                            ))}
                        </ul>
                    </nav>
                </div>

                {/* Collapsed navigation for desktop only */}
                {!isMobile && !isOpen && (
                    <div className="flex-1 overflow-y-auto">
                        <nav className="mt-4 pb-4">
                            <ul className="space-y-1 px-2">
                                {filteredNavItems.map((item) => (
                                    <li key={item.path}>
                                        <NavLink
                                            to={item.path}
                                            end={item.path === "/"}
                                            className={({ isActive }) => `
                                                flex items-center justify-center p-3 rounded-md transition-all duration-200 group
                                                ${isActive
                                                    ? "bg-primary/10 text-primary"
                                                    : "text-gray-700 hover:bg-gray-100 hover:text-gray-900"}
                                            `}
                                            title={item.name}
                                        >
                                            <span className="w-5 h-5 flex items-center justify-center">
                                                {item.icon}
                                            </span>
                                        </NavLink>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </div>
                )}

                {/* User section */}
                <div className="border-t border-gray-200 p-3 sm:p-4 flex-shrink-0">
                    <div className={`flex items-center ${!isMobile && !isOpen ? 'justify-center' : 'gap-3'}`}>
                        {user?.imageId ? (
                            <img
                                src={getImg(user?.imageId)}
                                alt={`dr ${user?.firstName} ${user?.lastName}`}
                                className="w-9 h-9 sm:w-11 sm:h-11 rounded-full object-cover bg-gray-200 flex-shrink-0"
                            />
                        ) : (
                            <div className="w-9 h-9 sm:w-11 sm:h-11 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0">
                                <span className="text-gray-500 text-lg">
                                    {user?.firstName?.charAt(0)}{user?.lastName?.charAt(0)}
                                </span>
                            </div>
                        )}
                        {(isOpen || isMobile) && (
                            <div className="min-w-0 flex-1">
                                <p className="font-medium text-xs sm:text-sm text-gray-900 truncate">
                                    dr.{user?.firstName} {user?.lastName}
                                </p>
                                <p className="text-xs text-gray-500 truncate">{user?.email}</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Sidebar;